import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Message from "../../tools/Message";
import {
  Alert,
  Autocomplete,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Spacer from "../../../components/Spacer";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@material-ui/core/TextField";
import MainContainer from "../../../components/MainContainer";
import { headerDataImmo } from "../../../data/modules/logistic-header";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import {
  FormControl,
  IconButton,
  Collapse,
  AppBar,
  Box,
  Tooltip,
  Popper,
} from "@material-ui/core";
import VehicleService from "../../../services/VehicleService";
import MissionVehicleDetailAdd from "./MissionVehicleDetailAdd";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Add, Delete } from "@mui/icons-material";
import MissionTransportService from "../../../services/MissionTransportService";
import { AntTab, AntTabs } from "../../../components/ant-tab";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import SendIcon from "@mui/icons-material/Send";
import MissionVehicleRequest from "./MissionVehicleRequest";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "100%",
  },
  tab: {
    minWidth: "400px !important",
    fontSize: "0.8rem",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  box: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: "8px !important",
    maxWidth: "156vh",
    minWidth: "100vh",
  },
}));

export default function MissionVehicleAdd() {
  const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();
  const missionId = id ? id : null;
  const [openRows, setOpenRows] = useState({});
  const [formValues, setFormValues] = useState({
    mission_id: missionId,
    agendas: [{ agenda_id: 0, destinations: [] }],
  });
  const [voituresAvalailable, setVoituresAvalailable] = useState([]);
  const [missionData, SetMissionData] = useState({});
  const [confirmationDialog, setConfirmationDialog] = useState({
    openDialog: false,
    messageDialog: "Voulez vous vraiment supprimer  ?",
  });
  const [confirmTransport, setConfirmTransport] = useState({// pour la confirmation de la gestion du transport
    open: false,
    mission_id: 0,
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [affiche, setAffiche] = useState(false);
  const [listedestination, setListedestination] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] =
    useState(false);
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehicleCaptains, setVehicleCaptains] = useState({}); // pour les chefs de bord
  const [vehicleDetailData, setVehicleDetailData] = useState({
    openDialog: false,
    closeDialog: false,
    missionnary: [],
  });
  const [warning, setWarning] = useState({
    show: false,
    vehicleImm: "",
    index: null,
    tIndex: null,
  });
  const [formRequest, setFormRequest] = useState({// pour la demande de la sollicitation voiture
    show: false,
    direction: null,
    description: "",
    missionnaries: {},
    allMissionnaries: [],
    destination: {},
    agendaId: 0,
    missionId: 0,
  });
  const [value, setValue] = useState(0);
  const [confirmationOM, setConfirmationOM] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [captainConfirm, setCaptainConfirm] = useState({
    open: false,
    missionnary: "",
    vehicle: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [currentaxe, setCurrentaxe] = useState({
    open: false,
    depart: "",
    destination1: "",
    destination2: "",
  });
  const [formAxe, setFormAxe] = useState({});
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})/);
    if (!match) return "";
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`.trim();
  };

  useEffect(() => {
    async function fetchMissionDetails() {
      // recuperaion des données
      setOpenLoadingSimpleBackdrop(true);
      try {
        const result = await MissionTransportService.getDataMission(missionId); // Récupérer les informations de la mission
        if (result?.data) {
          const mission = result.data;
          SetMissionData(mission || {});

          if (mission.agendas?.length) {
            const agendas = mission.agendas; // listesdes agendas de la misison

            let allDestinations = [];
            let allVehicles = [];
            let allDrivers = [];
            const [driversResult, vehiclesResult] = await Promise.all([  // Récupérer chauffeurs et véhicules
              VehicleService.getDriversMission(),
              VehicleService.getAllVehicles(),
            ]);

            if (driversResult?.data) {
              allDrivers = driversResult.data;
              setDrivers(driversResult.data);
            }
            if (vehiclesResult?.data) {
              allVehicles = vehiclesResult.data;
              setVehicles(vehiclesResult.data);
            }

            for (const agenda of agendas) { // Parcourir chaque agenda
              if (agenda?.mission_planning_agenda_id) {
                const agendaDestinations =
                  await MissionTransportService.getagendaTransport(
                    agenda.mission_planning_agenda_id
                  ); // Récupérer les détails de l'agenda
                if (agendaDestinations?.data) {
                  setAffiche(true);
                  setListedestination((prev) => [
                    ...prev,
                    {
                      agenda_id: agenda.mission_planning_agenda_id,
                      destinations: agendaDestinations.data,
                    },
                  ]);

                  const transformedDestinations = agendaDestinations.data.map(
                    (item) => {
                      setVoituresAvalailable((prev) => [
                        ...prev,
                        ...item.voituresAvalaible,
                      ]); // voitures disponibles
                      setIsEdit(item.transports && item.transports.length > 0); // Vérifier si c'est un mode modification
                     
                      return {
                        mission_destination_id: item.mission_destination_id,
                        transports:
                          item.transports && item.transports.length > 0 // transports : pour les transports déjà configuré / il s'agit d'une modification
                            ? item.transports.map((transport) => {
                                const vehicle =
                                  allVehicles.find(
                                    (v) =>
                                      v.vhc_id ===
                                      transport.mission_planning_voiture_id
                                  ) || null;
                                const driver =
                                  vehicle?.vhc_type == "FID"
                                    ? allDrivers.find(
                                        (d) => d.user_id === vehicle?.driver_id
                                      )
                                    : vehicle?.driver_name || null;
                                const captain = transport.missionnaries.find(
                                        (u) => u.user_id == transport.captain_id
                                      ) || null;

                                return {
                                  type: vehicle?.vhc_type || "FID",
                                  vehicle,
                                  driver,
                                  driverContact: "",
                                  captain,
                                  missionnaries: transport.missionnaries,
                                  missionary_timesheet_mobility_id:
                                    transport.missionary_timesheet_mobility_id,
                                  transport_id : transport.transport_id,
                                  purpose: transport.transport_purpose,
                                };
                              })
                            : [
                                {
                                  // si il n'y a pas encore de transports configuré, initialiser avec une valeur par défaut
                                  type: "",
                                  vehicle: null,
                                  driver: null,
                                  driverContact: "",
                                  captain: null,
                                  transport_id: null,
                                  missionary_timesheet_mobility_id: null,
                                  missionnaries: item.missionnaries,
                                  purpose: null,
                                },
                              ],
                      };
                    }
                  );
                  allDestinations.push({
                    agenda_id: agenda.mission_planning_agenda_id,
                    reference: agenda.reference,
                    destinations: transformedDestinations,
                  });
                }
              }
            }
            setFormValues((prev) => ({
              ...prev,
              agendas: allDestinations,
            }));
          }
        } else {
          SetMissionData({});
        }
      } catch (error) {
        console.error("Error fetching mission details:", error);
      } finally {
        setOpenLoadingSimpleBackdrop(false);
      }
    }

    // Appel des fonctions pour récupérer les données
    fetchMissionDetails();
  }, [missionId]);

  useEffect(() => {
    function handleColapse() {
      // pour reinitialiser les lignes ouvertes
      const newOpenRows = {};
      listedestination.forEach((_, index) => {
        newOpenRows[index] = true;
      });
      setOpenRows(newOpenRows);
    }
    handleColapse();
  }, [listedestination]);

  function handleCloseMessage() {
    // fermeture de la message
    setMessage({ ...message, open: false });
  }

  function compareDistrictCommune(district1, district2) {
    // Comparaison des districts et communes
    if (!district1 || !district2) return true;
    return (
      district1.replace(/\s+/g, "").toUpperCase() ==
      district2.replace(/\s+/g, "").toUpperCase()
    );
  }

  function handleCaptainChange(
    captain,
    vehicle,
    agendaIndex,
    destinationIndex,
    transportIndex
  ) {
    // Gestion du changement de chef de bord
    if (vehicle && captain) {
      let vehicleId = vehicle?.vhc_id;
      setCaptainConfirm({
        open: true,
        missionnary: captain.nom,
        vehicle: vehicleId,
        immatriculation:
          formValues.agendas[agendaIndex].destinations[destinationIndex]
            ?.transports[transportIndex]?.vehicle?.vhc_imm,
      });
      setVehicleCaptains((prevCaptains) => ({
        ...prevCaptains,
        [vehicleId]: captain,
      }));
    }
  }

  function handleChange(
    event,
    name,
    value,
    agendaIndex,
    destinationIndex,
    transportIndex
  ) {
    // Gestion des changements dans le formulaire
    event.preventDefault();
    const vehicle =
      formValues.agendas[agendaIndex].destinations[destinationIndex].transports[
        transportIndex
      ].vehicle || null;
    if (name === "captain") {
      // Un chef de bord pour une voiture durant une mission
      handleCaptainChange(
        value,
        vehicle,
        agendaIndex,
        destinationIndex,
        transportIndex
      );
    }

    if (name === "vehicle") {
      // Vérification si le nombre de missionnaires dépasse la capacité du véhicule
      const missionnaries =
        formValues.agendas[agendaIndex].destinations[destinationIndex]
          .transports[transportIndex].missionnaries || [];
      const captain =
        formValues.agendas[agendaIndex].destinations[destinationIndex]
          .transports[transportIndex].captain || null;
      if (value && missionnaries.length > value.vhc_place) {
        setWarning({
          show: true,
          vehicleImm: value.vhc_imm,
          index: destinationIndex,
          tIndex: transportIndex,
        });
      } else {
        setWarning({ show: false, vehicleImm: "", index: null, tIndex: null });
      }
      handleCaptainChange(
        captain,
        value,
        agendaIndex,
        destinationIndex,
        transportIndex
      );
    }

    if (name === "missionnaries") {
      // Vérification si le nombre de missionnaires dépasse la capacité du véhicule
      const vehicle =
        formValues.agendas[agendaIndex].destinations[destinationIndex]
          .transports[transportIndex].vehicle;
      if (vehicle && value.length > vehicle.vhc_place) {
        setWarning({
          show: true,
          vehicleImm: vehicle.vhc_imm,
          index: destinationIndex,
          tIndex: transportIndex,
        });
      } else {
        setWarning({ show: false, vehicleImm: "", index: null, tIndex: null });
      }
    }

    setFormValues((prev) => {
      const updateTransport = (transport) => ({
        ...transport,
        [name]: name === "driverContact" ? formatPhoneNumber(value) : value,
        ...(name === "vehicle" && {
          type: value.vhc_type,
          driver:
            drivers.find((driver) => driver.user_id === value.driver_id) ||
            value.driver_name + " - " + value.driver_contact,
          captain: vehicleCaptains[value.vhc_id] || transport.captain,
        }),
        ...(name === "captain" && {
          missionnaries: value
            ? transport.missionnaries.some((m) => m.user_id === value.user_id)
              ? transport.missionnaries
              : [
                  ...transport.missionnaries,
                  missionData?.missionnaries.find(
                    (user) => user.user_id === value.user_id
                  ),
                ]
            : transport.missionnaries,
        }),
      });

      return {
        ...prev,
        agendas: prev.agendas.map((agenda, aIndex) =>
          aIndex === agendaIndex
            ? {
                ...agenda,
                destinations: agenda.destinations.map((destination, dIndex) =>
                  dIndex === destinationIndex
                    ? {
                        ...destination,
                        transports: destination.transports.map(
                          (transport, tIndex) =>
                            tIndex === transportIndex
                              ? updateTransport(transport)
                              : transport
                        ),
                      }
                    : destination
                ),
              }
            : agenda
        ),
      };
    });
  }

  const handleConfirmTransport = async () => {
    try {
      const missionId = confirmTransport.mission_id;
      setConfirmTransport({
        open: false,
        mission_id: 0,
      });
      setOpenLoadingSimpleBackdrop(true); // Active le chargement

      await MissionTransportService.confirmTransportMission(missionId);
      const result = await MissionTransportService.sendDriverOM(missionId);

      if (result) {
        setMessage({
          open: true,
          color: "green",
          messageInfo: "Gestion du transport confirmée.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de la confirmation du transport :", error);
      setMessage({
        open: true,
        color: "red",
        messageInfo: "Échec de la confirmation du transport.",
      });
    } finally {
      setOpenLoadingSimpleBackdrop(false); // Désactive le chargement dans tous les cas
    }
  };

  // const prepareDataToSend = (formValues) => {
  //   const transports = [];

  //   formValues.agendas.forEach((agenda) => {
  //     agenda.destinations.forEach((destination) => {
  //       destination.transports.forEach((transport) => {
  //         transport?.missionnaries.forEach((missionnary) => {
  //           transports.push({
  //             mission_planning_transport_type: transport.type,
  //             vhc_id: transport.vehicle?.vhc_id || null,
  //             driver_id: transport.driver?.user_id || null,
  //             missionary_timesheet_mobility_id:
  //               transport?.missionary_timesheet_mobility_id || null,
  //             driver_contact: transport.driverContact || null,
  //             captain_id: transport.captain?.user_id || null,
  //             mission_id: formValues.mission_id,
  //             agenda_id: agenda.agenda_id || null,
  //             mission_planning_agenda_details_id:
  //               missionnary.mission_planning_agenda_details_id,
  //             purpose: transport.purpose,
  //             mission_destination_id : destination.mission_destination_id,
  //           });
  //         });
  //       });
  //     });
  //   });
  //   return transports;
  // };
 const prepareDataToSend = (formValues) => {
  const transportsList = [];

  formValues.agendas.forEach((agenda) => {
    agenda.destinations.forEach((destination) => {
      destination.transports.forEach((transport) => {
        const transportId = transport?.transport_id;
        const vhcId = transport.vehicle?.vhc_id || null;

        if(vhcId) {
        let existingEntry = transportsList.find(
          (t) => t.transport_id === transportId && t.vhc_id === vhcId
        );

        if (!existingEntry) {
          existingEntry = {
            transport_id: transportId,
            vhc_id: vhcId,
            driver_id: transport.driver?.user_id || null,
            driver_contact: transport.driverContact || null,
            captain_id: transport.captain?.user_id || null,
            details: [],
          };
          transportsList.push(existingEntry);
        }

        // Ajouter les missionnaires aux détails
        transport?.missionnaries?.forEach((missionnary) => {
          existingEntry.details.push({
            transport_id: transportId,
            agenda_id: agenda.agenda_id || null,
            mission_planning_agenda_details_id:
              missionnary.mission_planning_agenda_details_id,
            mission_destination_id: destination.mission_destination_id,
            purpose: transport.purpose,
            missionary_timesheet_mobility_id: transport.missionary_timesheet_mobility_id,
          });
        });
        }
      });
      
    });
  });

  return transportsList;
};



  const handleSave = async (finalize = false) => {
    setOpenLoadingSimpleBackdrop(true);
    try {
      const dataToSend = prepareDataToSend(formValues);

      const result = await MissionTransportService.saveTransportMission(
        dataToSend
      );
      if (formAxe.length > 0) {
        const axeResult = await MissionTransportService.saveAxes(formAxe);
        if (!axeResult?.status) {
          setMessage({
            open: true,
            color: "red",
            messageInfo: "Erreur lors de l'enregistrement de l'axe",
          });
          return;
        }
      }

      if (!result?.status) {
        setMessage({
          open: true,
          color: "red",
          messageInfo: "Erreur lors de l'enregistrement des données",
        });
        return;
      }

      setMessage({
        open: true,
        color: "green",
        messageInfo: "Les données ont été enregistrées avec succès",
      });

      if (finalize == true) {
        navigate("/Logistic/mission/transport_managment");
        return;
      }

      setConfirmationOM(true);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error);
      setMessage({
        open: true,
        color: "red",
        messageInfo: "Une erreur inattendue est survenue",
      });
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  };

  const handleSubmitAndGenerateOM = async () => {
    setOpenLoadingSimpleBackdrop(true);
    try {
      setConfirmationOM(false);
      await MissionTransportService.confirmTransportMission(missionId);
      const finalizeResult = await MissionTransportService.sendDriverOM(
        missionId
      );

      if (!finalizeResult) {
        setMessage({
          open: true,
          color: "red",
          messageInfo: "Erreur lors de la génération de l'ordre de mission",
        });
        return;
      }
      setMessage({
        open: true,
        color: "green",
        messageInfo: "Gestion du transport confirmée.",
      });

      navigate("/Logistic/mission/transport_managment");
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des données :", error);
      setMessage({
        open: true,
        color: "red",
        messageInfo: "Une erreur inattendue est survenue",
      });
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  };

  const handleClose = () => {
    navigate("/Logistic/mission/transport_managment");
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleOpenDialogDetail = () => {
    setVehicleDetailData({
      ...vehicleDetailData,
      openDialog: true,
    });
  };

  const handleCloseDialogDetail = () => {
    setVehicleDetailData({ ...vehicleDetailData, openDialog: false });
  };

  const handleToggleRow = (index) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const handleAddTransport = (agendaIndex, destinationIndex) => {
    const newTransport = {
      type: "FID",
      vehicle: null,
      driver: "",
      chefDeBord: null,
      missionnaries: [],
    };

    setFormValues((prev) => {
      const shouldUpdateAllDestinations = !isEdit && destinationIndex === 0;
      return {
        ...prev,
        agendas: prev.agendas.map((agenda, aIndex) =>
          aIndex === agendaIndex
            ? {
                ...agenda,
                destinations: agenda.destinations.map((destination, dIndex) =>
                  // shouldUpdateAllDestinations && dIndex === destinationIndex
                  dIndex === destinationIndex
                    ? {
                        ...destination,
                        transports: [...destination.transports, newTransport],
                      }
                    : destination
                ),
              }
            : agenda
        ),
      };
    });
  };

  const handleRemoveTransport = (
    agendaIndex,
    destinationIndex,
    transportIndex
  ) => {
    setFormValues((prev) => ({
      ...prev,
      agendas: prev.agendas.map((agenda, aIndex) =>
        aIndex === agendaIndex
          ? {
              ...agenda,
              destinations: agenda.destinations.map((destination, index) =>
                index === destinationIndex
                  ? {
                      ...destination,
                      transports: destination.transports.filter(
                        (_, i) => i !== transportIndex
                      ),
                    }
                  : destination
              ),
            }
          : agenda
      ),
    }));
  };

  const handleShowRequestDialog = (agendaIndex, destinationIndex) => {
    //reinitilisation formulaire de sollicitation de voiture

    const agenda = listedestination[agendaIndex];
    const destination = agenda.destinations[destinationIndex];
    const missionnaries = destination.missionnaries;
    setFormRequest({
      ...formRequest,
      show: true,
      missionnaries,
      allMissionnaries: destination.missionnaries,
      destination: destination,
      agendaId: agenda.agenda_id,
      missionId: missionId,
    });
  };

  return (
    <React.Fragment>
      <MissionVehicleDetailAdd
        openDialog={vehicleDetailData.openDialog}
        closeDialog={handleCloseDialogDetail}
        missionnary={missionData?.missionnary}
      />
      <MainContainer {...headerDataImmo}>
        <LoadingSimpleBackdrop
          openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
        />
        <Message
          open={open}
          color={color}
          messageInfo={messageInfo}
          handleClose={handleCloseMessage}
        />

        <AppBar position="static" color="default" className={classes.AppBar}>
          <AntTabs
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <AntTab
              disableRipple
              label="Gestion de transport par ligne de l'agenda"
              className={classes.tab}
            />
          </AntTabs>
        </AppBar>
        <Spacer y={2} />
        <Grid
          container
          xs={12}
          spacing={2}
          justifyContent="center"
          display="flex"
          flexDirection="row"
          sx={{ margin: "0.25%" }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>
                Réference de la mission
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.reference}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>
                {" "}
                Lieu(x) de(s) destination(s)
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.lieu}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>Date de debut</label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={formatDate(missionData.date_begin)}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>Date de fin</label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={formatDate(missionData.date_end)}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>
                {" "}
                Objet de la mission
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.mission_title}
                name="code"
                type="text"
                fullWidth
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>
                {" "}
                Moyen(s) de transport{" "}
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.transports}
                name="code"
                type="text"
                fullWidth
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>Missionnaires </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                multiline
                rows={4}
                value={
                  missionData?.missionnaries
                    ? missionData.missionnaries
                        .map((user) => `- ${user.name}`)
                        .join("\n")
                    : ""
                }
                onChange={handleChange}
                variant="outlined"
                fullWidth
                disabled
                sx={{ width: 100 }}
                InputProps={{
                  sx: {
                    overflow: "auto",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2} padding="2">
          <Paper variant="outlined" className={classes.paper}>
            {affiche && (
              <Grid container sx={{ margin: 2, width: "100%" }}>
                {formValues.agendas?.map(
                  (
                    agenda,
                    agendaIndex // Boucle sur les agendas
                  ) => (
                    <Grid item xs={12} key={agendaIndex} container>
                      <fieldset
                        style={{
                          borderRadius: "10px",
                          color: "#1976d2",
                          fontSize: "24px",
                        }}
                      >
                        <legend>
                          &nbsp;&nbsp;
                          {`Agenda ${agendaIndex + 1} : ${agenda.reference}`}
                          &nbsp; &nbsp;
                        </legend>
                        <Grid item xs={12}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead
                              sx={{
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                maxHeight: "10px !important",
                              }}
                            >
                              <TableRow>
                                <TableCell sx={{ width: 10 }} />
                                <TableCell sx={{ width: 150 }}>Date</TableCell>
                                <TableCell sx={{ width: 200 }}>Heure</TableCell>
                                <TableCell sx={{ width: 240 }}>Lieu</TableCell>
                                <TableCell sx={{ width: 300 }}>
                                  Transport souhaité
                                </TableCell>
                                <TableCell sx={{ width: 150 }}>Type</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {listedestination
                                .find(
                                  (dest) => dest.agenda_id === agenda.agenda_id
                                )
                                ?.destinations.map((destination, index) => (
                                  <React.Fragment key={index}>
                                    <TableRow
                                      sx={{
                                        backgroundColor: openRows[index]
                                          ? "rgba(242, 242, 242, 0.8)"
                                          : "inherit",
                                        "&:hover": {
                                          backgroundColor:
                                            "rgba(0, 123, 255, 0.1)",
                                        },
                                      }}
                                    >
                                      <TableCell>
                                        <span style={{ color: "#1976d2" }}>
                                          {index + 1}.
                                        </span>
                                        <IconButton
                                          size="small"
                                          onClick={() => handleToggleRow(index)}
                                        >
                                          {openRows[index] ? (
                                            <KeyboardArrowUp color="info" />
                                          ) : (
                                            <KeyboardArrowDown color="info" />
                                          )}
                                        </IconButton>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {formatDate(destination.date_begin)} -{" "}
                                          {formatDate(destination.date_end)}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {`${destination.heure_begin} - ${destination.heure_end}`}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {destination.type === "DR"
                                            ? `${destination.depart} - ${destination.arriver}`
                                            : destination.activite === "mis"
                                            ? destination.region
                                            : destination.direction_code}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {destination.transport_type}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        {destination.type === "DM" ? (
                                          <Chip
                                            icon={<CardTravelIcon />}
                                            label="Mission"
                                            variant="outlined"
                                            color="info"
                                          />
                                        ) : (
                                          <Chip
                                            icon={<TimeToLeaveIcon />}
                                            label="Délai de route"
                                            variant="outlined"
                                            color="info"
                                          />
                                        )}
                                      </TableCell>
                                    </TableRow>

                                    {/* Sous-tableau des détails */}
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          paddingBottom: 0,
                                          paddingTop: 0,
                                        }}
                                        colSpan={6}
                                      >
                                        <Collapse
                                          in={openRows[index]}
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <Spacer y={1} />
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              className={classes.labelPosition}
                                              style={{
                                                color: "grey",
                                                marginTop: "5px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Détails voiture(s)
                                            </label>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                              }}
                                            >
                                              {/* <Tooltip
                                                title="Demander une sollicitation des voitures à une direction"
                                                arrow
                                              >
                                                <Button
                                                  startIcon={<SendIcon />}
                                                  onClick={() =>
                                                    handleShowRequestDialog(
                                                      agendaIndex,
                                                      index
                                                    )
                                                  }
                                                  variant="outlined"
                                                >
                                                  Solliciter{" "}
                                                </Button>
                                              </Tooltip> */}
                                              <Spacer x={1} />
                                              <Tooltip
                                                title="Ajouter une ligne"
                                                arrow
                                              >
                                                <Button
                                                  variant="contained"
                                                  color="info"
                                                  size="small"
                                                  sx={{width: "140px", fontSize: "10px"}}
                                                  onClick={() =>
                                                    handleAddTransport(
                                                      agendaIndex,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <Add sx={{ fontSize: "12px"}}/> Ajouter voiture
                                                </Button>
                                              </Tooltip>
                                            </div>
                                          </div>
                                          {warning.show &&
                                          warning.index === index ? (
                                            <Alert severity="warning" fullWidth>
                                              Le nombre de missionnaires dépasse
                                              la capacité du voiture{" "}
                                              {warning.vehicleImm}
                                            </Alert>
                                          ) : null}
                                          <Box className={classes.box}>
                                            <TableContainer
                                              component={Paper}
                                              style={{
                                                overflowX: "auto",
                                                marginTop: "1%",
                                                marginBottom: "2%",
                                                boxShadow:
                                                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                                borderRadius: "6px",
                                                marginLeft: "0.5%",
                                                width: "99%",
                                              }}
                                            >
                                              <Table size="small" aria-label="sous-tableau"
                                              >
                                                <TableRow>
                                                  {( destination?.transport_type != null && (destination?.transport_type.toUpperCase() ==
                                                    "AVION" ||
                                                    destination?.transport_type.toUpperCase() ==
                                                      "BATEAU") &&
                                                  destination?.type === "DR") ? (
                                                    <TableCell
                                                      style={{
                                                        fontWeight: "bold",
                                                        minWidth: "200px",
                                                      }}
                                                    >
                                                      Type
                                                    </TableCell>
                                                  ) : null}
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "360px",
                                                    }}
                                                  >
                                                    Voiture
                                                  </TableCell>
                                                  {/* <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "300px",
                                                    }}
                                                  >
                                                    Chauffeur
                                                  </TableCell> */}
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "360px",
                                                    }}
                                                  >
                                                    Chef de bord
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "280px",
                                                    }}
                                                  >
                                                    Missionnaire(s)
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      position: "sticky",
                                                      right: 0,
                                                      background: "#fff",
                                                      zIndex: 1,
                                                      width: "50px",
                                                    }}
                                                  ></TableCell>
                                                </TableRow>
                                                <TableBody>
                                                  {/* Boucle sur les transports associés à la destination */}
                                                  {(
                                                    agenda.destinations.find(
                                                      (dest) =>
                                                        dest.id ===
                                                        destination.id
                                                    )?.transports || []
                                                  ).map((transport, tIndex) => (
                                                    <TableRow key={tIndex}>
                                                      {( destination?.transport_type != null && (destination?.transport_type.toUpperCase() ==
                                                        "AVION" ||
                                                        destination?.transport_type.toUpperCase() ==
                                                          "BATEAU") &&
                                                      destination?.type ===
                                                        "DR") ? (
                                                        <TableCell>
                                                          <FormControl
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                          >
                                                            <Autocomplete
                                                              id="tags-outlined"
                                                              options={[
                                                                "aller",
                                                                "retour",
                                                              ]}
                                                              getOptionLabel={(
                                                                option
                                                              ) =>
                                                                option ===
                                                                "aller"
                                                                  ? "Aller"
                                                                  : "Récuperation"
                                                              }
                                                              filterSelectedOptions
                                                              onChange={(
                                                                event,
                                                                value
                                                              ) =>
                                                                handleChange(
                                                                  event,
                                                                  "purpose",
                                                                  value,
                                                                  agendaIndex,
                                                                  index,
                                                                  tIndex
                                                                )
                                                              }
                                                              value={
                                                                transport.purpose
                                                              }
                                                              name={"Type"}
                                                              renderInput={(
                                                                params
                                                              ) => (
                                                                <TextField
                                                                  {...params}
                                                                  fullWidth
                                                                  id="outlined-basic"
                                                                  size="small"
                                                                  variant="outlined"
                                                                  label="Type"
                                                                />
                                                              )}
                                                              sx={{
                                                                "& .MuiInputBase-root":
                                                                  {
                                                                    height: 40,
                                                                  },
                                                                "& .MuiInputBase-input":
                                                                  {
                                                                    padding:
                                                                      "4px 8px",
                                                                  },
                                                              }}
                                                            />
                                                          </FormControl>
                                                        </TableCell>
                                                      ) : null}
                                                      <TableCell
                                                        style={{
                                                          minWidth: "360px",
                                                        }}
                                                      >
                                                        <FormControl
                                                          fullWidth
                                                          variant="outlined"
                                                          size="small"
                                                        >
                                                          <Autocomplete
                                                            id="tags-outlined"
                                                            options={
                                                              voituresAvalailable[
                                                                index
                                                              ]
                                                            }
                                                            getOptionLabel={(
                                                              option
                                                            ) =>
                                                              `${option.vhc_imm} (voiture ${option.vhc_type} - ${option.vhc_place} places disponibles)`
                                                            }
                                                            filterSelectedOptions
                                                            onChange={(
                                                              event,
                                                              value
                                                            ) => {
                                                              handleChange(
                                                                event,
                                                                "vehicle",
                                                                value,
                                                                agendaIndex,
                                                                index,
                                                                tIndex
                                                              );
                                                              //comparer les districts ou communes s'il sont le meme
                                                              if (
                                                                !compareDistrictCommune(
                                                                  value.district_arriver,
                                                                  destination.district_arriver
                                                                ) ||
                                                                !compareDistrictCommune(
                                                                  value.commune_arriver,
                                                                  destination.commune_arriver
                                                                )
                                                              ) {
                                                                setCurrentaxe({
                                                                  show: true,
                                                                  depart:
                                                                    value.depart,
                                                                  destination1:
                                                                    value.arriver,
                                                                  destination2:
                                                                    destination.arriver,
                                                                });
                                                              }
                                                            }}
                                                            sx={{
                                                              "& .MuiInputBase-root":
                                                                { height: 40 },
                                                              "& .MuiInputBase-input":
                                                                {
                                                                  padding:
                                                                    "4px 8px",
                                                                },
                                                            }}
                                                            value={
                                                              transport.vehicle
                                                            }
                                                            renderInput={(
                                                              params
                                                            ) => (
                                                              <TextField
                                                                {...params}
                                                                label="Voiture"
                                                                variant="outlined"
                                                                size="small"
                                                              />
                                                            )}
                                                            renderOption={(
                                                              props,
                                                              option
                                                            ) => {
                                                              return (
                                                                <li
                                                                  {...props}
                                                                  onMouseEnter={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      option.depart &&
                                                                      option.arriver
                                                                    ) {
                                                                      setHoveredOption(
                                                                        option
                                                                      );
                                                                      setAnchorEl(
                                                                        e.currentTarget
                                                                      );
                                                                    }
                                                                  }}
                                                                  onMouseLeave={() => {
                                                                    setHoveredOption(
                                                                      null
                                                                    );
                                                                    setAnchorEl(
                                                                      null
                                                                    );
                                                                  }}
                                                                >
                                                                  {`${option.vhc_imm} (voiture ${option.vhc_type} - ${option.vhc_place} places disponibles)`}
                                                                </li>
                                                              );
                                                            }}
                                                          />
                                                          <Popper
                                                            open={Boolean(
                                                              hoveredOption
                                                            )}
                                                            anchorEl={anchorEl}
                                                            placement="right-start"
                                                            style={{
                                                              zIndex: 1500,
                                                              pointerEvents:
                                                                "none",
                                                              boxShadow:
                                                                "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                                                              borderRadius:
                                                                "6px",
                                                            }}
                                                          >
                                                            {hoveredOption && (
                                                              <Box
                                                                sx={{
                                                                  bgcolor:
                                                                    "background.paper",
                                                                  p: 2,
                                                                  border: 1,
                                                                  boxShadow: 3,
                                                                  minWidth: 250,
                                                                }}
                                                              >
                                                                <Typography
                                                                  variant="subtitle2"
                                                                  gutterBottom
                                                                  color="primary"
                                                                >
                                                                  <b>
                                                                    {
                                                                      hoveredOption.vhc_imm
                                                                    }{" "}
                                                                    -{" "}
                                                                    {
                                                                      hoveredOption.vhc_place
                                                                    }{" "}
                                                                    place(s)
                                                                    disponible(s)
                                                                  </b>
                                                                </Typography>
                                                                <Typography
                                                                  variant="subtitle2"
                                                                  gutterBottom
                                                                >
                                                                  <i>Mission parallèle </i> :{" "}
                                                                </Typography>
                                                                <Typography
                                                                  variant="subtitle2"
                                                                  gutterBottom
                                                                >
                                                                { formatDate(hoveredOption.date_begin)}  - { formatDate(hoveredOption.date_end)} : 
                                                                  {
                                                                    hoveredOption.depart
                                                                  }{" "}
                                                                  -{" "}
                                                                  {
                                                                    hoveredOption.arriver
                                                                  } 
                                                                </Typography>
                                                              </Box>
                                                            )}
                                                          </Popper>
                                                          <Spacer y={1} />
                                                             <TextField
                                                          fullWidth
                                                          size="small"
                                                          variant="outlined"
                                                          value={
                                                            transport.type ===
                                                            "FID"
                                                              ? transport
                                                                  ?.driver
                                                                  ?.name || ""
                                                              : transport?.driver ||
                                                                ""
                                                          }
                                                          name="driver"
                                                          label="Chauffeur"
                                                          disabled
                                                        />
                                                        </FormControl>
                                                      </TableCell>

                                                      {/* <TableCell
                                                        style={{
                                                          minWidth: "300px",
                                                        }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          size="small"
                                                          variant="outlined"
                                                          value={
                                                            transport.type ===
                                                            "FID"
                                                              ? transport
                                                                  ?.driver
                                                                  ?.name || ""
                                                              : transport?.driver ||
                                                                ""
                                                          }
                                                          name="driver"
                                                          label="Chauffeur"
                                                          disabled
                                                        />
                                                      </TableCell> */}
                                                      <TableCell
                                                        style={{
                                                          minWidth: "360px",
                                                        }}
                                                      >
                                                        <Autocomplete
                                                          options={
                                                            destination?.missionnaries || missionData?.missionnaries || []}
                                                          getOptionLabel={(
                                                            option
                                                          ) =>
                                                            option
                                                              ? option?.nom?.toString()
                                                              : ""
                                                          }
                                                          filterSelectedOptions
                                                          onChange={(
                                                            event,
                                                            value
                                                          ) => {
                                                            handleChange(
                                                              event,
                                                              "captain",
                                                              value,
                                                              agendaIndex,
                                                              index,
                                                              tIndex
                                                            )
                                                          }}
                                                          value={
                                                            transport.captain
                                                          }
                                                          renderInput={(
                                                            params
                                                          ) => (
                                                            <TextField
                                                              {...params}
                                                              label="Chef de bord"
                                                              variant="outlined"
                                                              size="small"
                                                            />
                                                          )}
                                                          sx={{
                                                            "& .MuiInputBase-root":
                                                              { height: 40 },
                                                            "& .MuiInputBase-input":
                                                              {
                                                                padding:
                                                                  "4px 8px",
                                                              },
                                                          }}
                                                        />
                                                      </TableCell>
                                                      <TableCell
                                                        style={{
                                                          minWidth: "280px",
                                                        }}
                                                      >
                                                        <Autocomplete
                                                          multiple
                                                          options={destination?.missionnaries || missionData?.missionnaries || [] }
                                                          getOptionLabel={(
                                                            option
                                                          ) =>
                                                            option
                                                              ? option?.nom?.toString()
                                                              : ""
                                                          }
                                                          filterSelectedOptions
                                                          onChange={(
                                                            event,
                                                            newValue
                                                          ) =>
                                                            handleChange(
                                                              event,
                                                              "missionnaries",
                                                              newValue,
                                                              agendaIndex,
                                                              index,
                                                              tIndex
                                                            )
                                                          }
                                                          value={
                                                            transport.missionnaries
                                                          }
                                                          renderInput={(
                                                            params
                                                          ) => (
                                                            <TextField
                                                              {...params}
                                                              label="Missionnaire"
                                                              variant="outlined"
                                                              size="small"
                                                            />
                                                          )}
                                                        />
                                                      </TableCell>

                                                      <TableCell
                                                        style={{
                                                          position: "sticky",
                                                          right: 0,
                                                          background: "#fff",
                                                          zIndex: 1,
                                                          width: "50px",
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title="Supprimer la ligne"
                                                          arrow
                                                        >
                                                          <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                              handleRemoveTransport(
                                                                agendaIndex,
                                                                index,
                                                                tIndex
                                                              )
                                                            }
                                                          >
                                                            <Delete color="error" />
                                                          </IconButton>
                                                        </Tooltip>
                                                      </TableCell>
                                                    </TableRow>
                                                  ))}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                ))}
                            </TableBody>
                          </Table>
                        </Grid>
                      </fieldset>
                    </Grid>
                  )
                )}
              </Grid>
            )}
            <Box
              container
              item
              xs={12}
              spacing={2}
              display="flex"
              justifyContent="flex-end"
              sx={{ marginTop: "20px", marginBottom: "20px" }}
            >
              <Button
                variant="contained"
                color="error"
                size="medium"
                style={{ marginRight: "30px" }}
                onClick={handleClose}
                autoFocus
              >
                Annuler
              </Button>
              <Button
                variant="contained"
                color="info"
                size="medium"
                style={{ marginRight: "30px" }}
                onClick={() => handleSave(true)}
                autoFocus
              >
                Enregistrer
              </Button>
              {/* <Button
                variant="contained"
                color="info"
                size="medium"
                style={{ marginRight: "30px" }}
                onClick={() => {
                  handleSave(false);
                }}
                autoFocus
              >
                Enregistrer et Confirmer
              </Button> */}
            </Box>
          </Paper>
        </Grid>

        <Dialog
          open={confirmationOM}
          onClose={() => setConfirmationOM(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {
                "La gestion du transport sera Confirmée. L'Ordre de Mission (OM) du chauffeur sera envoyé au chauffeur."
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              component="span"
              onClick={() => {
                setConfirmationOM(false);
                navigate("/Logistic/mission/transport_managment");
              }}
            >
              Anuller
            </Button>
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={() => handleSubmitAndGenerateOM()}
            >
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={captainConfirm.open}
          onClose={() =>
            setCaptainConfirm({
              open: false,
              missionnary: "",
              vehicle: "",
            })
          }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {`${captainConfirm.missionnary} sera le chef de bord de la voiture ${captainConfirm.immatriculation} durant la mission.`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={() => {
                setCaptainConfirm({
                  open: false,
                  missionnary: "",
                  vehicle: "",
                });
              }}
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={currentaxe.show}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() =>
            setCurrentaxe({
              show: false,
              depart: "",
              destination1: "",
              destination2: "",
            })
          }
        >
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              <Typography>
                Êtes-vous sûr de vouloir mettre ces missionnaires dans la même
                voiture ?
              </Typography>
              <Typography>Sont-ils sur le même axe ?</Typography>
              <Table aria-label="simple table" sx={{ mt: 2 }}>
                <TableHead
                  sx={{ backgroundColor: "rgb(254, 254, 254) !important" }}
                >
                  <TableCell>Destination 1</TableCell>
                  <TableCell>Destination 2</TableCell>
                </TableHead>
                <TableBody>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      <i>Départ : {currentaxe.depart} </i>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Arrivée : {currentaxe.destination1}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      <i>Départ : {currentaxe.depart} </i>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Arrivée : {currentaxe.destination2}
                    </Typography>
                  </TableCell>
                </TableBody>
              </Table>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setCurrentaxe({
                  show: false,
                  depart: "",
                  destination1: "",
                  destination2: "",
                });
              }}
              variant="outlined"
              color="info"
              autoFocus
            >
              Non
            </Button>
            <Button
              onClick={() => {
                setFormAxe((prev, index) => ({
                  ...prev,
                  [index]: {
                    ...prev[index],
                    depart: currentaxe.depart,
                    destination_a: currentaxe.destination1,
                    destination_b: currentaxe.destination2,
                  },
                }));
                setCurrentaxe({
                  show: false,
                  depart: "",
                  destination1: "",
                  destination2: "",
                });
              }}
              variant="contained"
              color="info"
            >
              Oui
            </Button>
          </DialogActions>
        </Dialog>
        <MissionVehicleRequest
          formRequest={formRequest}
          setFormRequest={setFormRequest}
          setMessage={setMessage}
        />
      </MainContainer>
    </React.Fragment>
  );
}
